export default class IconsWithCopy {
    constructor() {
        if(('.icons-with-text-carousel')[0]) {
            $(window).on('load resize orientationchange', function () {
                $('.icons-with-text-carousel').each(function () {
                    var $carousel = $(this);
                    /* Initializes a slick carousel only on mobile screens */
                    // slick on mobile
                    if ($(window).width() > 767.99) {
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('unslick');
                        }
                    } else {
                        if (!$carousel.hasClass('slick-initialized')) {
                            $carousel.slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                mobileFirst: true,
                                arrows: true,
                                dots: true,
                                appendDots: $('#dots-'+$carousel.data('id')),
                            });
                        }
                    }
                });
            });
        }
    }
}

new IconsWithCopy();


// WEBPACK FOOTER //
// ../views/modules/icons-with-copy/assets/js/icons-with-copy.js